(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amn-collection"]) return;
  try {
    
  // Desktop sort dropdown — preserves all active filter params
  (function() {
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('.amn-sort__option[data-sort-value]');
      if (!btn) return;

      const sortValue = btn.dataset.sortValue;
      if (!sortValue) return;

      const details = btn.closest('.amn-sort__details');
      if (details) details.open = false;

      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortValue);
      url.searchParams.delete('page');

      window.location.href = url.toString();
    });
  })();

  // Load more products
  (function() {
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('.amn-collection__load-more');
      if (!btn) return;

      const nextUrl = btn.dataset.nextUrl;
      // section-id живёт на родительском grid-wrapper, а не только на кнопке
      const gridWrapper = btn.closest('[id^="amn-collection-grid-"]');
      const sectionId = gridWrapper
        ? gridWrapper.id.replace('amn-collection-grid-', '')
        : btn.dataset.sectionId;

      if (!nextUrl || !sectionId) return;

      btn.classList.add('amn-collection__load-more--loading');
      btn.disabled = true;

      fetch(nextUrl)
        .then(function(res) { return res.text(); })
        .then(function(html) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          // 1. Добавляем новые карточки
          const newGrid = doc.getElementById('amn-product-list-' + sectionId);
          const currentGrid = document.getElementById('amn-product-list-' + sectionId);
          if (newGrid && currentGrid) {
            Array.from(newGrid.children).forEach(function(item) {
              currentGrid.appendChild(item);
            });
          }

          // 2. Меняем блок пагинации (новая кнопка с data-next-url следующей страницы)
          const newPagination = doc.getElementById('amn-pagination-' + sectionId);
          const currentPagination = document.getElementById('amn-pagination-' + sectionId);
          if (newPagination && currentPagination) {
            currentPagination.innerHTML = newPagination.innerHTML;
          }

          // 3. Обновляем счётчик "Показано X з Y" — считаем реальный DOM
          const shownNumEl = currentPagination
            ? currentPagination.querySelector('.amn-shown-num')
            : null;
          if (shownNumEl) {
            const totalVisible = document.querySelectorAll(
              '#amn-product-list-' + sectionId + ' .amn-collection__grid-item'
            ).length;
            shownNumEl.textContent = totalVisible;
          }

          // 4. Обновляем URL без перезагрузки
          history.pushState({}, '', nextUrl);
        })
        .catch(function() {
          btn.classList.remove('amn-collection__load-more--loading');
          btn.disabled = false;
        });
    });
  })();

  // Auto-scroll active category link into view
  (function() {
    const activeLink = document.querySelector('.amn-collection__category-link--active');
    if (activeLink) {
      activeLink.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'center' });
    }
  })();

  // Mobile grid toggle (1 / 2 columns)
  (function() {
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('.amn-collection__grid-btn');
      if (!btn) return;

      const toggle = btn.closest('.amn-collection__grid-toggle');
      if (!toggle) return;

      const cols = parseInt(btn.dataset.columns, 10);
      const sectionId = toggle.id.replace('amn-grid-toggle-', '');
      const grid = document.querySelector('#amn-collection-grid-' + sectionId);

      if (!grid) return;

      toggle.querySelectorAll('.amn-collection__grid-btn').forEach(function(b) {
        b.classList.remove('amn-collection__grid-btn--active');
      });
      btn.classList.add('amn-collection__grid-btn--active');

      grid.dataset.mobileColumns = cols;
    });
  })();

  // Price filter accordion toggle + open by default
  (function() {
    function initPriceAccordion(filter) {
      var header = filter.querySelector('.amn-price-filter__header');
      var body   = filter.querySelector('.amn-price-filter__body');
      if (!header || !body) return;

      // Open by default
      filter.classList.add('amn-price-filter--open');
      body.style.maxHeight = '120px';

      header.addEventListener('click', function() {
        var isOpen = filter.classList.contains('amn-price-filter--open');
        if (isOpen) {
          filter.classList.remove('amn-price-filter--open');
          body.style.maxHeight = '0';
        } else {
          filter.classList.add('amn-price-filter--open');
          body.style.maxHeight = '120px';
        }
      });
    }

    function initAllPriceAccordions() {
      document.querySelectorAll('.amn-price-filter').forEach(function(el) {
        if (!el.dataset.accordionInit) {
          el.dataset.accordionInit = '1';
          initPriceAccordion(el);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllPriceAccordions);
    } else {
      initAllPriceAccordions();
    }
  })();

  // Dynamic filter count — fetch on drawer input change, apply on submit
  (function() {
    var debounceTimer = null;

    function updateDrawerCount(form) {
      var sectionId     = form.dataset.sectionId;
      var collectionUrl = form.dataset.collectionUrl;
      var btn           = document.getElementById('amn-drawer-show-btn-' + sectionId);
      if (!btn || !collectionUrl) return;

      var params = new URLSearchParams(new FormData(form));
      params.delete('page');

      fetch(collectionUrl + '?' + params.toString() + '&section_id=' + sectionId)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var doc     = new DOMParser().parseFromString(html, 'text/html');
          var countEl = doc.getElementById('amn-section-products-count-' + sectionId);
          if (!countEl) return;
          var count = parseInt(countEl.dataset.count, 10);
          if (isNaN(count)) return;
          btn.textContent = count > 0 ? 'ПОКАЗАТИ ' + count + ' ТОВАРІВ' : 'НІЧОГО НЕ ЗНАЙДЕНО';
          btn.disabled    = count === 0;
        })
        .catch(function() {});
    }

    // Checkboxes / selects
    document.addEventListener('change', function(e) {
      var form = e.target.closest('.amn-filters-drawer__form');
      if (!form) return;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() { updateDrawerCount(form); }, 400);
    });

    // Range slider (fires 'input')
    document.addEventListener('input', function(e) {
      if (!e.target.classList.contains('amn-price-slider__input')) return;
      var form = e.target.closest('.amn-filters-drawer__form');
      if (!form) return;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() { updateDrawerCount(form); }, 600);
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }
  // Desktop sort dropdown — preserves all active filter params
  (function() {
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('.amn-sort__option[data-sort-value]');
      if (!btn) return;

      const sortValue = btn.dataset.sortValue;
      if (!sortValue) return;

      const details = btn.closest('.amn-sort__details');
      if (details) details.open = false;

      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortValue);
      url.searchParams.delete('page');

      window.location.href = url.toString();
    });
  })();

  // Auto-scroll active category link into view
  (function() {
    const activeLink = document.querySelector('.amn-collection__category-link--active');
    if (activeLink) {
      activeLink.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'center' });
    }
  })();

  // Mobile grid toggle (1 / 2 columns)
  (function() {
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('.amn-collection__grid-btn');
      if (!btn) return;

      const toggle = btn.closest('.amn-collection__grid-toggle');
      if (!toggle) return;

      const cols = parseInt(btn.dataset.columns, 10);
      const sectionId = toggle.id.replace('amn-grid-toggle-', '');
      const grid = document.querySelector('#amn-collection-grid-' + sectionId);

      if (!grid) return;

      toggle.querySelectorAll('.amn-collection__grid-btn').forEach(function(b) {
        b.classList.remove('amn-collection__grid-btn--active');
      });
      btn.classList.add('amn-collection__grid-btn--active');

      grid.dataset.mobileColumns = cols;
    });
  })();

  // Price filter accordion toggle + open by default
  (function() {
    function initPriceAccordion(filter) {
      var header = filter.querySelector('.amn-price-filter__header');
      var body   = filter.querySelector('.amn-price-filter__body');
      if (!header || !body) return;

      // Open by default
      filter.classList.add('amn-price-filter--open');
      body.style.maxHeight = '120px';

      header.addEventListener('click', function() {
        var isOpen = filter.classList.contains('amn-price-filter--open');
        if (isOpen) {
          filter.classList.remove('amn-price-filter--open');
          body.style.maxHeight = '0';
        } else {
          filter.classList.add('amn-price-filter--open');
          body.style.maxHeight = '120px';
        }
      });
    }

    function initAllPriceAccordions() {
      document.querySelectorAll('.amn-price-filter').forEach(function(el) {
        if (!el.dataset.accordionInit) {
          el.dataset.accordionInit = '1';
          initPriceAccordion(el);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllPriceAccordions);
    } else {
      initAllPriceAccordions();
    }
  })();

  // Dynamic filter count — fetch on drawer input change, apply on submit
  (function() {
    var debounceTimer = null;

    function updateDrawerCount(form) {
      var sectionId     = form.dataset.sectionId;
      var collectionUrl = form.dataset.collectionUrl;
      var btn           = document.getElementById('amn-drawer-show-btn-' + sectionId);
      if (!btn || !collectionUrl) return;

      var params = new URLSearchParams(new FormData(form));
      params.delete('page');

      fetch(collectionUrl + '?' + params.toString() + '&section_id=' + sectionId)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var doc     = new DOMParser().parseFromString(html, 'text/html');
          var countEl = doc.getElementById('amn-section-products-count-' + sectionId);
          if (!countEl) return;
          var count = parseInt(countEl.dataset.count, 10);
          if (isNaN(count)) return;
          btn.textContent = count > 0 ? 'ПОКАЗАТИ ' + count + ' ТОВАРІВ' : 'НІЧОГО НЕ ЗНАЙДЕНО';
          btn.disabled    = count === 0;
        })
        .catch(function() {});
    }

    // Checkboxes / selects
    document.addEventListener('change', function(e) {
      var form = e.target.closest('.amn-filters-drawer__form');
      if (!form) return;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() { updateDrawerCount(form); }, 400);
    });

    // Range slider (fires 'input')
    document.addEventListener('input', function(e) {
      if (!e.target.classList.contains('amn-price-slider__input')) return;
      var form = e.target.closest('.amn-filters-drawer__form');
      if (!form) return;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() { updateDrawerCount(form); }, 600);
    });
  })();


  } catch(e) { console.error(e); }
})();
})();
